module.exports = __webpack_public_path__ + "img/prestations.15b8ef4c.webp";